import { Badge } from "@/components/ui/badge";

export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "—";

export const apiError = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const LastChanged = ({ item, testId, className = "" }) => (
  <p className={`text-xs text-muted-foreground ${className}`} data-testid={testId}>
    Zuletzt geändert am {fmtDateTime(item?.updated_at)}
    {item?.updated_by_name ? ` von ${item.updated_by_name}` : ""}
  </p>
);

export const VendorStatusBadge = ({ status, testId }) =>
  status === "inactive" ? (
    <Badge variant="outline" className="bg-slate-100 text-slate-600 border-slate-200 shrink-0" data-testid={testId}>Inaktiv</Badge>
  ) : (
    <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 shrink-0" data-testid={testId}>Aktiv</Badge>
  );

export const VENDOR_CATEGORIES = ["Praxisverwaltung (PVS)", "Terminbuchung", "Telematik", "Abrechnung", "Kommunikation", "Sonstiges"];
export const DOC_CATEGORIES = ["Vertrag", "Anleitung", "Handbuch", "Preisliste", "Sonstiges"];
